import { useEffect } from 'react'
import { useQueryObjectiveAccessesForTermsQuery } from '@/store/api/aggregatesApi'
import { useAppDispatch } from '@/store/hooks'
import { resetAggregates } from '@/store/slices/aggregatesSlice'
import { useGetEnrolledCourseTermsFilter } from './useGetEnrolledCourseTermsFilter'

export const useLoadEnrolledCourses = () => {
  const dispatch = useAppDispatch()

  const { filter: termsFilter, select: termsSelect } = useGetEnrolledCourseTermsFilter()

  useQueryObjectiveAccessesForTermsQuery(
    {
      query: {
        filter: termsFilter,
        select: termsSelect,
      },
    },
    {
      refetchOnMountOrArgChange: true,
    },
  )

  useEffect(() => {
    return () => {
      dispatch(resetAggregates())
    }
  }, [dispatch])
}
